import { Core } from './core'

export class Zendesk {
  constructor () {
    if (Core.isAdmin()) return;
    this.scriptEl = document.getElementById('ze-snippet');
    if ( !this.scriptEl ) return;

    this.initZendesk()
  }

  initZendesk() {
    if (Core.isBpLessThan('xl')) return;
    this.scriptEl.src = this.scriptEl.dataset.init;
  }
}
